import { Container, Grid, Box } from '@mui/material'
import { useState, useEffect } from 'react'
import { Paper } from '@material-ui/core'

import BankingChart from '../../common/BankingChart/BankingChart'
import { getBankingHistoryExtranet } from './api/apiBankingHistory'
import LoadingScreen from '../../common/LoadingScreen/components/LoadingScreen'

export const BankingHistoryExtranet = ({ coproId }) => {
  const [bankingHistoryData, setBankingHistoryData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const fetchBankingHistory = async () => {
      setIsLoading(true)

      const res = await getBankingHistoryExtranet(coproId)
      setBankingHistoryData(res)

      setIsLoading(false)
    }
    fetchBankingHistory()
  }, [])

  return (
    <Box component={Paper} padding={'25px'}>
      <Container disableGutters style={{ maxWidth: '100%' }}>
        <Grid item xs={12}>
          {isLoading ? (
            <LoadingScreen />
          ) : (
            <BankingChart bankingHistoryData={bankingHistoryData} />
          )}
        </Grid>
      </Container>
    </Box>
  )
}
